<template>
  <div>
    <iframe
      :src="embedUrl"
      width="100%"
      frameborder="0"
      scrolling="no"
      allowtransparency="true"
      :class="$style.iframe"
    ></iframe>
  </div>
</template>
<script>
export default {
  name: 'InstagramCard',
  components: {},

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    embedUrl() {
      return this.item.embed_link.embed_url.replace(/\?.*/, '') + 'embed'
    },
  },
}
</script>

<style lang="scss" module>
.iframe {
  height: 605px;
  border-radius: 8px;
  @include below(large) {
    height: 555px;
  }
  @include below(small) {
    height: 525px;
  }
}
</style>
